import { ChangeEvent } from 'react';
import SearchInput from '@/creditflowresearch/ui/common/components/molecules/SearchInput';
import { TileHeader } from '@creditflowresearch/uilib/Tile';
import Title from '@creditflowresearch/uilib/Title';
import Flex from '@creditflowresearch/uilib/Flex';
import Button from '@creditflowresearch/uilib/Button';
import { Link } from '@framework/router/Next/Link';
import {
  useArticlesTileContext,
} from '@/creditflowresearch/application/ArticlesAndStats/Articles/ArticlesTile/ArticlesTileContext';
import {
  mapArticleTypeToTitle,
} from '@/creditflowresearch/ui/components/creditFlow/articles/constants';
import { useGetLinkToAllArticles } from '@/creditflowresearch/ui/components/creditFlow/articles/common/useGetLinkToAllArticles';
import TileSubscribeButton from '@/creditflowresearch/ui/components/creditFlow/articles/ArticlesTiles/TileSubscribeButton';
import { getTrimmedString } from '@/creditflowresearch/ui/common/helpers/getTrimmedString';

import styles from './articlesTile.module.scss';

const ArticlesTileHeader = () => {
  const {
    setSearch,
    search,
    themeType,
    articlesData: { debouncedSearch },
    isSubscribeButtonVisible,
  } = useArticlesTileContext();

  const onSearchChange = ({ target: { value } }: ChangeEvent<HTMLInputElement>): void => {
    setSearch(value);
    const filteredValue = getTrimmedString(value);
    if (filteredValue === null) return;
    debouncedSearch(filteredValue);
  };

  const { link, tooltip } = useGetLinkToAllArticles(themeType);

  return (
    <TileHeader
      title={ <Title title={ mapArticleTypeToTitle[themeType] } /> }
      dataTest={ `articlesTileHeader-${ themeType }` }
    >
      <Flex
        direction={ { sm: 'column-reverse', md: 'column-reverse', xl: 'row' } }
        align={ { sm: 'stretch', md: 'stretch', xl: 'center' } }
        gap={ 10 }
      >
        <SearchInput
          onChange={ onSearchChange }
          value={ search }
          placeholder="Filter by Headline or Description"
          formFieldClassName={ styles.searchInputField }
          className={ styles.search }
        />
        <Flex align="center" gap={ 10 }>
          { isSubscribeButtonVisible && <TileSubscribeButton themeType={ themeType } buttonClassName="" /> }
          <Button
            as={ Link }
            to={ link }
            variant="outline"
            size="S"
            fit={ { sm: 'full', md: 'full' } }
            dataTest={ `articlesTileAllButton-${ themeType }` }
            ariaLabel={ tooltip }
          >
            { `All ${ mapArticleTypeToTitle[themeType] }` }
          </Button>
        </Flex>
      </Flex>
    </TileHeader>
  );
};

export default ArticlesTileHeader;
